module.exports = __webpack_public_path__ + "img/malaysia.a466b25.webp";